import { BoxContainer } from '@components/common';
import css from './index.module.scss';
import QuotePricePackageWrapper from '@components/common/quote-wrapper/components/quote-price-package-wrapper';
import { useFormContext } from 'react-hook-form';
import { CURRENCY } from '@helpers/constants';
import { Typography } from '@components/base';

const freightChargeTypes = [
  {
    id: 'prepaid',
    label: 'Prepaid',
    amountKey: 'freightCharges.prepaid',
    currencyKey: 'freightCharges.prepaidCurrency'
  },
  {
    id: 'collect',
    label: 'Collect',
    amountKey: 'freightCharges.collect',
    currencyKey: 'freightCharges.collectCurrency'
  },
  {
    id: 'thirdParty',
    label: '3rd Party',
    amountKey: 'freightCharges.thirdParty',
    currencyKey: 'freightCharges.thirdPartyCurrency'
  }
];

const FreightAndCharges = () => {
  const {
    control,
    formState: { errors }
  } = useFormContext();

  return (
    <BoxContainer
      className={css.mainWrapper}
      title={
        <div className={css.title}>
          Freight Charges
          <span className={css.required}>*</span>
        </div>
      }
    >
      <div className={css.boxWrapper}>
        <div className={css.rowWrapper}>
          {freightChargeTypes.map((chargeType) => (
            <QuotePricePackageWrapper
              key={chargeType.id}
              label={chargeType.label}
              control={control}
              input={chargeType.amountKey}
              inputPlaceholder="Enter Price"
              currency={chargeType.currencyKey}
              currencyOptions={CURRENCY}
              currencyPlaceholder="Currency"
            />
          ))}
        </div>
        <Typography variant="ptext" className={css.freightChargesError}>
          {errors && errors?.freightCharges && errors?.freightCharges?.message}
        </Typography>
      </div>
    </BoxContainer>
  );
};

export default FreightAndCharges;
